//SASS
import "../sass/main.scss";
//COMPONENTS
import { getChildsNav } from "./components/Nav";
import { getChildScrollSmoth } from "./components/ScrollSmoth";
import { getChildsParallax } from "./components/Parallax";
import { getChildsGeneral } from "./components/General";
import { getChildsModal } from "./components/Modal";
import { getChildsCookies } from "./components/Cookies";
//LIBRARY
import { getChildsAos } from "./library/LibAos";
import { getChildsSwiper } from "./library/LibSwiper";
//ANIMATIONS
import { scrollingPage } from './partials/animations';
//PAGES
import { getChildsDetailProject } from "./pages/detailProject";
import { getChildsDetailProjectmin } from "./pages/detailProject";
import { getChildsJobs } from "./pages/jobs";
import { revealSecondsSection } from "./pages/contact";


window.addEventListener('load', ()=>{
    scrollingPage();
    getChildsNav();
    getChildScrollSmoth();
    getChildsAos();
    getChildsSwiper();
    getChildsParallax();
    getChildsDetailProject();
    getChildsDetailProjectmin();
    getChildsJobs();
    revealSecondsSection();
    getChildsGeneral();
    getChildsModal();
    getChildsCookies();
});